import { motion } from "framer-motion";
import { Reveal, RevealWords, Overline } from "./shared";

const A = "https://customer-assets.emergentagent.com/job_gabicom-animated-hub/artifacts";

const partners = [
  { name: "Microsoft Solutions Partner", logo: `${A}/5dkk5ay6_Screenshot%202026-07-11%20215017.png` },
  { name: "Dell Technologies Partner", logo: `${A}/qhl4mirs_dell.png` },
  { name: "D&H", logo: `${A}/cmxd9ntq_images.png` },
  { name: "Ingram Micro Xvantage", logo: `${A}/407bkm5i_ingra.jpeg` },
  { name: "TD SYNNEX", logo: `${A}/j6har5cu_images.jpeg` },
  { name: "Tenable Authorized Reseller", logo: "/partners/tenable.png" },
  { name: "Joy Systems", logo: "/partners/joy.png" },
  { name: "PCI Brand Ink & Toner", logo: "/partners/pci.png" },
  { name: "HP Business Partner", logo: `${A}/0ugr1vsy_hp-partner-logo.png` },
];

export default function Partners() {
  return (
    <section
      id="partners"
      data-testid="partners-section"
      className="relative mx-auto max-w-7xl px-6 py-16 md:py-24"
    >
      <div className="mb-12 max-w-2xl">
        <Reveal>
          <Overline>Trusted alliances</Overline>
        </Reveal>
        <RevealWords
          text="Our technology partners"
          className="font-display mt-5 text-4xl font-semibold leading-tight text-white md:text-5xl"
        />
        <Reveal delay={0.2}>
          <p className="mt-5 max-w-xl text-[#a0aec0]">
            We partner with the world&apos;s leading vendors and distributors to bring you
            genuine products, better pricing and enterprise-grade solutions.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-3">
        {partners.map((p, i) => (
          <Reveal key={p.name} delay={i * 0.05}>
            <motion.div
              whileHover={{ y: -6 }}
              transition={{ type: "spring", stiffness: 250, damping: 20 }}
              data-testid={`partner-${i}`}
              className="group flex h-32 items-center justify-center overflow-hidden rounded-2xl border border-white/10 bg-white/[0.02] p-6 transition-colors hover:border-[#00f0ff]/40"
            >
              {p.logo ? (
                <img
                  src={p.logo}
                  alt={p.name}
                  loading="lazy"
                  className="max-h-16 max-w-full object-contain transition-transform duration-300 group-hover:scale-105"
                />
              ) : (
                <span className="font-display text-center text-xl font-semibold leading-tight text-white md:text-2xl">
                  {p.name}
                </span>
              )}
            </motion.div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
